export class AuthViewModel {
    userName = '';
    password = '';
    app = '';
}